import Banner from "../components/Banner";
import GaleriaCard from "../components/GaleriaCard";
import galeria from "../assets/galeria_2022.jpg";
import React, { useEffect, useState } from "react";
import axios from "axios";

const Galeria = () => {
  const [usersRegistered, setusersRegistered] = useState(null);
  const [lastPageUrl, setlastPageUrl] = useState(null);
  const [firstPageUrl, setfirstPageUrl] = useState(null);
  const [lastPage, setLastPage] = useState(null);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [numberCard, setnumberCard] = useState(0);
  const [positionSlide, setPositionSlide] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);

  useEffect(() => {
    var ahora = new Date();
    var milisegundos = ahora.getMilliseconds();

    axios({
      url:
        "https://mmkg.net/api/casate/get-all-registers/" +
        100 +
        "?v=" +
        milisegundos,
      method: "GET",
    })
      .then((response) => {
        console.error(response);
        setusersRegistered(response.data.data);
        setfirstPageUrl(response.data.first_page_url);
        setlastPageUrl(response.data.last_page_url);
        setLastPage(response.data.last_page);
        setnumberCard(response.data.total);
        setNextPage(response.data.next_page_url);
        setPrevPage(response.data.prev_page_url);
        setCurrentPosition(response.data.current_page);
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  const contenidoBanner = {
    titulo: "Galería",
    texto:
      "Ellos ya están participando por la boda de sus sueños. No se queden fuera y compartan su historia.",
    imagen: galeria,
  };

  function updateData(url) {
    console.info(url);
    var ahora = new Date();
    var milisegundos = ahora.getMilliseconds();

    axios({
      url: url + "&v=" + milisegundos,
      method: "GET",
    })
      .then((response) => {
        setusersRegistered(response.data.data);
        setfirstPageUrl(response.data.first_page_url);
        setlastPageUrl(response.data.last_page_url);
        setLastPage(response.data.last_page);
        setNextPage(response.data.next_page_url);
        setPrevPage(response.data.prev_page_url);
        setCurrentPosition(response.data.current_page);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function nextPageSlider(url) {
    console.info(url);
    var ahora = new Date();
    var milisegundos = ahora.getMilliseconds();

    axios({
      url: url + "&v=" + milisegundos,
      method: "GET",
    })
      .then((response) => {
        setusersRegistered(response.data.data);
        setfirstPageUrl(response.data.first_page_url);
        setlastPageUrl(response.data.last_page_url);
        setLastPage(response.data.last_page);
        setNextPage(response.data.next_page_url);
        setPrevPage(response.data.prev_page_url);
        setCurrentPosition(response.data.current_page);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  

  const paginationNumber = () => {
    let button = [];
    for (let i = 1; i <= lastPage; i++) {
      button.push(<button disabled={lastPage > 1 ? false : true} class={currentPosition === i ? 'page-link active' : 'page-link'} onClick={() => updateData("https://mmkg.net/api/casate/get-all-registers/100?page=" + i)}>
                    <li class="page-item">{i}</li>
                  </button>);
    }
    return button;
  }

  return (
    <>
      <Banner contenidoBanner={contenidoBanner} />
      {/* <div className="containerTelon">
        <div className="telon"></div>
      </div> */}
      <div className="global__margintop container">
        <div className="row justify-content-center flex-column">
          {numberCard > 0 ? (
            <div class="w-100">
            <GaleriaCard users={usersRegistered} />
              <nav aria-label="Page navigation example" >
                <ul class="pagination justify-content-center mt-5">
                  <button
                    class="page-link"
                    onClick={() => updateData(firstPageUrl, setPositionSlide(0))}
                    disabled={currentPosition === 1  ? true : false}
                  >
                    <li class="page-item">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="iconArrows">
                        <path d="M77.25 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C175.6 444.9 183.8 448 192 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L77.25 256zM269.3 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C367.6 444.9 375.8 448 384 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L269.3 256z"/>
                      </svg>
                    </li>
                  </button>
                  <button
                    class="page-link"
                    onClick={() => nextPageSlider(prevPage, setPositionSlide(positionSlide + 2.2))}
                    disabled={currentPosition === 1 || currentPosition <= 10 ? true : false}
                  >
                    <li class="page-item">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"  class="iconArrows">
                        <path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"/>
                      </svg>
                    </li>
                  </button>
                  <div class="paginationContainer d-flex">
                    <div class="d-flex paginationSlider" style={{ transform: 'translateX(' + positionSlide + 'rem)' }}>
                      {paginationNumber()}
                    </div>
                  </div>
                  <button
                    class="page-link">
                    <li class="page-item">
                    ...
                    </li>
                  </button>
                  <button
                    className={currentPosition >= 10 ? 'd-block page-link' : 'd-none page-link'}
                    onClick={() => nextPageSlider(nextPage, setPositionSlide(positionSlide - 2.2))}
                    disabled={currentPosition === lastPage ? true : false}
                  >
                    <li class="page-item">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="iconArrows">
                        <path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/>
                      </svg>
                    </li>
                  </button>
                  <button
                    class="page-link"
                    onClick={() => updateData(lastPageUrl, setPositionSlide((lastPage - 10) * -2.2))}
                    disabled={lastPage > 1 ? false : true}
                  >
                    <li class="page-item">
                      {lastPage}
                    </li>
                  </button>
                </ul>
              </nav> 
              {/* <div className="lds-roller d-block mx-auto">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <p className="text-center text-white pt-4">
                  Cargando usuarios...
                </p> */}
              </div>
          ) : (
            <div className="gallery_noData">
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Galeria;
